<template>
    <div class="more-wrapper">
        <div class="more-text-main">
            <div class="more-text-main__title">
                For more information & up to date news, follow us on our
                community channels
            </div>
            <div class="more-text-main__buttons">
                <default-button
                    class="more-text-main__button"
                    :color="'veryDarkBlue'"
                    :outside="true"
                    :text="'Twitter'"
                    :link="'https://twitter.com/ylandsgame'"
                    :width-static="'230px'"
                />

                <default-button
                    class="more-text-main__button"
                    :color="'veryDarkBlue'"
                    :outside="true"
                    :text="'Twitch'"
                    :link="'https://www.twitch.tv/ylands'"
                    :width-static="'230px'"
                />

                <default-button
                    class="more-text-main__button"
                    :color="'veryDarkBlue'"
                    :outside="true"
                    :text="'Discord'"
                    :link="'https://discord.com/invite/6Gcz5KN'"
                    :width-static="'230px'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/common/Button';
export default {
    name: 'LookForMore',
    components: {
        'default-button': Button,
    },
};
</script>

<style scoped lang="scss">
.more-wrapper {
    position: relative;
    overflow: hidden;
    height: $smallest-height;
    background: #ffcc18;
    @media (max-width: $lg-up) {
        height: 380px;
    }
    @media (max-width: $sm-up) {
        height: $small-height;
    }
}
.more-text-main {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 90%;
    width: 100%;

    &__title {
        text-align: center;
        font-family: $politica-font;
        font-size: 26px;
        font-weight: 700;
        letter-spacing: 0.52px;
        line-height: 40px;
        margin-bottom: 3rem;
    }
    .more-text-main__buttons {
        display: flex;
        width: 100%;
        justify-content: center;

        @media (max-width: $sm-up) {
            flex-direction: column;
            align-items: center;
        }

        .more-text-main__button {
            text-transform: uppercase;
            &:not(:first-child) {
                margin-left: 30px;
            }
            @media (max-width: $sm-up) {
                &:not(:first-child) {
                    margin-left: 0px;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>
